import cronstrue from 'cronstrue';
import {setupSchedulerScope} from '../scheduler'

angular
.module('logbook')
.directive('shiftScheduler', ['$timeout', '$q', function($timeout, $q)
{
    return {
        restrict: 'E',
		template: require('./shift-scheduler.html'),

        scope: {
            selectedLog: '=',
            shifts: '=',
            containerObject: '=',
            nameEnabled: '=',
            onBind: '='
        },


        link: function(scope, elem, attrs)
        {
            scope.shifts = (Array.isArray(scope.shifts)) ? scope.shifts : [];
            scope.scheduleType = 'shift';
            scope.scheduleName = scope.scheduleName || scope.scheduleType;

            scope.hadShiftLoad = true;
            scope.cells = {
                minutes: {
                    displayName: 'Minutes',
                    model: []
                },
                hours: {
                    displayName: 'Hours',
                    model: []
                },
                weekdays: {
                    displayName: 'Weekdays',
                    options: {
                        static: true,
                        onlyOne: true,
                        deleteable: false,
                        showBadge: false
                    },
                    model: []
                }
            };

            scope.cronDecorator = function(cron)
            {
                var shiftStr = scope.selectedShift ? ('During shift ' + (scope.selectedShift.name || scope.selectedShift.displayName) + ', ') : '';

                var localCron = JSON.parse(JSON.stringify(cron));
                if (scope.cells.hours.model.length && scope.cells.hours.model.every(function(cellObj) { return cellObj.model }))
                    localCron.hours = scope.cells.hours.model.reduce(function(specStr, cellObj, index)
                    {
                        var result = scope.cronConverters.hours.decorator[cellObj.subType](JSON.parse(JSON.stringify(cellObj.model.hours[cellObj.subType])));
                        return (!result)
                            ? specStr
                            : (specStr + ((index > 0) ? ',' : '') + result);
                    }, '');

                Object.keys(localCron).forEach(function(key)
                {
                    if (!localCron[key]) localCron[key] = '*'
                })
                var cronStr = shiftStr + cronstrue.toString(Object.values(localCron).join(' ')) + ((cron.weekdays === '*' && cron.monthdays === '*') ? ', everyday' : '');

                return cronStr;
            };

            // Parsers for cell objects to cron
            // { type: { subType: function } }
            Object.assign(scope.cronConverters = {
                    exact: function (settings)
                    {
                        return settings.value;
                    },
                    range: function (settings)
                    {
                        var toReturn = '';

                        var start = (settings.startEnabled && settings.start != undefined && !isNaN(settings.start))
                            ? settings.start
                            : 0;
                        var end = (settings.endEnabled && settings.end != undefined && !isNaN(settings.end))
                            ? settings.end
                            : 0;

                        if (start === 0 && end === 0)
                            toReturn = '*/';
                        else
                            toReturn = start + '-' + end + '/';

                        toReturn += settings.interval;
                        return toReturn;
                    }
                },
                {
                    minutes: {
                        exact: scope.cronConverters.exact,
                        range: scope.cronConverters.range
                    },
                    hours: {
                        exact: function(settings)
                        {
                            return 's' + settings.value;
                        },
                        range: function(settings)
                        {
                            return 's' + settings.start + '-s' + settings.end + '/' + settings.interval;
                        },
                        shift: function(settings)
                        {
                            var toReturn = [];

                            if (settings.afterStartEnabled)
                                toReturn.push('s' + settings.afterStart);

                            if (settings.beforeEndEnabled)
                                toReturn.push('e' + settings.beforeEnd);

                            return (toReturn.length) ? toReturn.join(',') : '';
                        },
                        decorator: {
                            exact: function(settings)
                            {
                                return (moment(scope.selectedShift.beginTime, 'HHmm').add(settings.value, 'hours').hours()).toString();
                            },
                            range: function(settings)
                            {
                                settings.start = moment(scope.selectedShift.beginTime, 'HHmm').add(settings.start, 'hours').hours();
                                settings.end = moment(scope.selectedShift.beginTime, 'HHmm').add(settings.end, 'hours').hours();
                                return scope.cronConverters.range(settings);
                            },
                            shift: function(settings)
                            {
                                var toReturn = [];
                                var shift = scope.selectedShift;
                                if (settings.afterStartEnabled) toReturn.push(shift.startMoment.clone().add(settings.afterStart, 'hours').hours());
                                if (settings.beforeEndEnabled) toReturn.push(shift.endMoment.clone().subtract(settings.beforeEnd, 'hours').hours());
                                return (toReturn.length) ? toReturn.join(',') : '';
                            }
                        }
                    },
                    weekdays: {
                        exact: function(settings)
                        {
                            var days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
                            var matches = Object.keys(settings)
                                .filter(function(key)
                                {
                                    return settings[key].selected === true
                                })
                                .map(function(key)
                                {
                                    return days.findIndex(function(value) { return key === value })
                                });
                            return (matches.length) ? matches.join(',') : '*';
                        }
                    },
                    monthdays: {
                        exact: scope.cronConverters.exact,
                        range: scope.cronConverters.range
                    }
                });

            //Parsers for cron to cell Objects
            Object.assign(scope.cronParsers = {

                    // Sub-type level parsers
                    exact: function(value, min, max)
                    {
                        var validationExp = /^\d+$/;
                        var parsed = parseInt(value);
                        if (value !== null && validationExp.test(value) && !isNaN(parsed) && parsed >= min && parsed <= max)
                            return { subType: 'exact', result: { value: parsed } }
                    },
                    range: function(value, min, max)
                    {
                        var rangeValidation = /(((\d+-\d+)|(\d+)|(\*))\/\d+|(\d+-\d+))/g;
                        var rangeMatcher = /(^\d+)|((?:(?!-)\d+))|(\d+$)/g;

                        if (!rangeValidation.test(value)) return;

                        var result = {  };
                        if (!value.includes('*'))
                        {
                            var parsed = value.match(rangeMatcher).map(function(value) { return parseInt(value); });
                            if (parsed.length > 1)
                            {
                                var start = parsed[0];
                                var end = parsed[1];

                                result.start = (start >= min) ? start : min;
                                result.end = (end <= max) ? end : max;
                                result.interval = (parsed.length >= 3) ? parsed[2] : 1;
                            }
                        }
                        else
                        {
                            var intervalMatcher = /(?:(?!\/)\d+$)/;
                            var matched = value.match(intervalMatcher);
                            result.start = min;
                            result.end = max;
                            result.interval = (matched.length === 1 && !isNaN(parseInt(matched[0])))
                                ? parseInt(matched[0])
                                : 1;
                        }
                        return { subType: 'range', result: result };
                    }
                },
                {
                    // Type level parsers
                    minutes: {
                        exact: function(value) { return scope.cronParsers.exact(value, 0, 59) },
                        range: function(value) { return scope.cronParsers.range(value, 0, 59) }
                    },
                    hours: {
                        exact: function(value)
                        {
                            return scope.cronParsers.exact(value.replace(/s/g, ''), 0, 23)
                        },
                        range: function(value)
                        {
                            return scope.cronParsers.range(value.replace(/s/g, ''), 0, 23)
                        },
                        shift: function(value)
                        {
                            if (!value.includes('e')) return;

                            value = value.replace(/s/g, '').replace(/e/g, '');
                            if (isNaN(parseInt(value))) return;

                            var resultObject;
                            return (resultObject = scope.cronParsers.exact(value, 0, 23))
                                ? { subType: 'shift', result: { afterStartEnabled: false, beforeEnd: resultObject.result.value }}
                                : undefined;
                        }
                    },
                    weekdays: {
                        exact: {
                            options: {
                                takesAll: true
                            },
                            parser: function(value)
                            {
                                var rangeMatcher = /(^\d+)|((?:(?!-)\d+))|(\d+$)/g;
                                var toReturn = {
                                    subType: 'exact',
                                    result: {
                                        Sun: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Mon: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Tues: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Wed: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Thurs: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Fri: {
                                            enabled: true,
                                            selected: false
                                        },
                                        Sat: {
                                            enabled: true,
                                            selected: false
                                        }
                                    }
                                };
                                var keys = Object.keys(toReturn.result);
                                if (Array.isArray(value) && rangeMatcher.test(value[0]))
                                {
                                    var resultGroups = value[0].match(rangeMatcher);
                                    if (resultGroups.length === 2)
                                        for (var i = parseInt(resultGroups[0]); i <= parseInt(resultGroups[1]); i++)
                                        {
                                            value.push(i);
                                        }
                                }

                                if (!Array.isArray(value) ||
                                    !(value = value.filter(function(index)
                                    {
                                        return !isNaN(parseInt(index)) && index !== null && (index >= 0 && index < keys.length)
                                    })).length)
                                    return;

                                value.forEach(function(index)
                                {
                                    toReturn.result[keys[index]].selected = true;
                                });

                                return toReturn;
                            }
                        }
                    },
                    monthdays: {
                        exact: function(value) { return scope.cronParsers.exact(value, 1, 31) },
                        range: function(value) { return scope.cronParsers.range(value, 1, 31) }
                    }
                });

            setupSchedulerScope(scope, elem, $timeout, $q);

            /**
             * Callback called when a new cell is created.
             * @param cell - The created cell
             */
            scope.onCellBind = function(cell)
            {
                cell.addOnDeleteEvent(function(cellScope, e)
                {
                    var index = scope.cells[cellScope.type].model.findIndex(function(cellObj)
                    {
                        return cellObj === cellScope.cellObj;
                    });

                    if (index >= 0)
                    {
                        scope.cells[cellScope.type].model.splice(index, 1);
                        $timeout(function ()
                        {
                            scope.setAddCellBtnState(cellScope.type, !(scope.cells[cellScope.type].model.length >= scope.cells[cellScope.type].maxItems));
                        });
                    }

                    scope.updateCronOutput();
                    scope.onChange();
                });

                cell.addOnChangeEvent(function(cellObj, event)
                {
                    scope.updateCronOutput();
                    scope.onChange();
                });
            };

            /**
             * Updates the output with the results of the cron converters
             */
            scope.updateCronOutput = function()
            {
                var result = scope.getConverterResult();
                $(elem).find('#heading-readable-output').html(result.decorated);

                console.log(Object.values(result.cron).join(' '));
            };

            /**
             * Sets the shift for this scheduler by ID
             * @param {number} shiftId - Shift ID
             * @return {Promise<Object>} - Returns promise of the scheduler scope
             */
            scope.setShiftFromId = function(shiftId)
            {
                scope.selectedShift = scope.shifts.find(function(shift) { return shift.id == shiftId });
                if (scope.selectedShift == undefined) return;

                var start = scope.selectedShift.startMoment = moment(scope.selectedShift.beginTime, 'HHmm');
                var end = scope.selectedShift.endMoment = moment(scope.selectedShift.endTime, 'HHmm');

                if (end.isBefore(start))
                    end.add(1, 'day');

                scope.selectedShift.duration = moment.duration(end.diff(start)).asHours();

                return $timeout(function()
                {
                    // Updates all cells with new selected shift
                    Object.keys(scope.cells).forEach(function(cell)
                    {
                        scope.cells[cell].model.forEach(function(cellModel)
                        {
                            if (cellModel.hasOwnProperty('setSelectedShift'))
                                cellModel.setSelectedShift(scope.selectedShift);
                        })
                    });
                    scope.updateCronOutput();
                })
                .then(function()
                {
                    $(elem).find('#select-shift').val(scope.selectedShift.id);

                    scope.onChange();
                    return $q(function(resolve)
                    {
                        resolve(scope)
                    })
                })
            };

            $(elem).find('#select-shift').change(function(event)
            {
                var selectedId = $(this).children('option:selected').attr('value');
                scope.setShiftFromId(selectedId);
            });

            if (typeof scope.onBind === 'function')
                scope.onBind(scope);

            $timeout(function()
            {
                $(elem).find('#select-shift').change();
            })
        }
    }
}]);